(function () {
  'use strict';

  const states = new WeakMap();
  const rootSelector = '[data-cmj-ring-v2]';
  const radioSelector = '[data-cmj-metal-variant]';
  const excludedModelFiles = new Set([
    'cmj-celeste-round-solitaire-ai-concept-05.webp',
    'cmj-celeste-round-solitaire-ai-concept-06.webp',
    'cmj-celeste-editorial-on-hand-3ct-ai-concept_aab8c025-9c92-46a7-9d6a-6aa939a264ed.png',
    'cmj-celeste-editorial-on-hand-20261018.png',
    'cmj-embrace-romantic-dinner-refined-white-square-4k_03db6a63-c9de-4afc-b209-29855834ed2a.jpg',
    'cmj-embrace-romantic-dinner-refined-yellow-square-4k_0e8fefb2-b7e3-421a-8062-618538f09b3c.jpg',
    'cmj-embrace-romantic-dinner-refined-rose-square-4k_9b8a1991-f554-448d-82c3-f07ca2fa131e.jpg',
    'cmj-elan-golden-trilogy-model-18k-white-gold-20261019.png',
    'cmj-elan-golden-trilogy-model-18k-yellow-gold-20261019.png',
    'cmj-elan-golden-trilogy-model-18k-rose-gold-20261019.png',
    'cmj-etoile-marquise-pave-model-18k-white-gold-20261019.png',
    'cmj-etoile-marquise-pave-model-18k-yellow-gold-20261019.png',
    'cmj-etoile-marquise-pave-model-18k-rose-gold-20261019.png',
    'cmj-alina-model-18k-yellow-gold-matched-20261018_52b0fc1c-f9f6-4ee2-8ea0-8d645aacfbd3.png',
    'cmj-alina-model-18k-rose-gold-matched-20261018_63c8f473-4e52-40fa-abef-7a62811d3f72.png',
    'cmj-amara-on-model-yellow-gold_caeed651-7829-43d1-aa39-e8075156f6b2.png',
    'cmj-amara-on-model-rose-gold_6d8d95f0-f9fa-44ee-8b35-d0281853c9cf.png'
  ]);

  function imageKey(source) {
    try {
      const url = new URL(source, document.baseURI);
      return url.pathname.replace(/^\/cdn\/shop\/files\//, '/files/').replace(/^\/s\/files\/(?:[^/]+\/){4}files\//, '/files/');
    } catch {
      return source || '';
    }
  }

  function imageSize(source, width) {
    try {
      const url = new URL(source, document.baseURI);
      if (url.pathname.includes('/files/')) url.searchParams.set('width', String(width));
      return url.href;
    } catch {
      return source;
    }
  }

  function getState(root) {
    if (!states.has(root)) {
      const main = root.querySelector('[data-cmj-ring-image]');
      let labels = {};
      try {
        labels = JSON.parse(root.querySelector('[data-cmj-view-labels]')?.textContent || '{}');
      } catch {}
      states.set(root, {
        main,
        width: main && main.getAttribute('width'),
        height: main && main.getAttribute('height'),
        views: [],
        gallery: null,
        variant: null,
        pending: false,
        extraViews: null,
        labels
      });
    }
    return states.get(root);
  }

  function showView(root, index) {
    const state = getState(root);
    const view = state.views[index];
    if (!state.main || !view) return;
    const main = state.main;
    if (main.getAttribute('src') !== view.src) {
      main.src = view.src;
      main.srcset = view.srcset || [600, 1000, 1600].map(width => imageSize(view.src, width) + ' ' + width + 'w').join(', ');
    }
    main.alt = view.alt;
    if (view.width) main.setAttribute('width', view.width);
    if (view.height) main.setAttribute('height', view.height);
    const caption = root.querySelector('[data-cmj-view-caption]');
    if (caption) {
      caption.textContent = state.labels[view.kind] || state.labels.detail || '';
      caption.hidden = !caption.textContent;
    }
    if (state.gallery) {
      state.gallery.querySelectorAll('[data-cmj-view-index]').forEach(button => {
        const active = Number(button.dataset.cmjViewIndex) === index;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    }
  }

  function modelViews(root, tone) {
    const views = [];
    root.querySelectorAll('[data-cmj-model-gallery]').forEach(group => {
      let visible = 0;
      group.querySelectorAll('[data-cmj-model-colour]').forEach(figure => {
        const image = figure.querySelector('img[src]');
        const filename = image ? imageKey(image.getAttribute('src')).split('/').pop() : '';
        const matches = figure.dataset.cmjModelColour === tone && !excludedModelFiles.has(filename);
        figure.hidden = !matches;
        if (!matches) return;
        if (!image) return;
        visible += 1;
        views.push({
          src: image.getAttribute('src'),
          srcset: image.getAttribute('srcset') || '',
          alt: image.alt,
          width: image.getAttribute('width'),
          height: image.getAttribute('height'),
          kind: 'on_hand'
        });
      });
      group.hidden = visible === 0;
    });
    return views;
  }

  function renderViews(root, views) {
    const state = getState(root);
    const seen = new Set();
    state.views = views.filter(view => {
      const key = imageKey(view.src);
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
    if (!state.gallery) {
      const mainFrame = root.querySelector('.cmj-ring-v2__main');
      if (!mainFrame) return;
      const gallery = document.createElement('div');
      gallery.className = 'cmj-ring-v2__view-gallery';
      gallery.dataset.cmjViewGallery = '';
      const heading = root.querySelector('h1[id]');
      if (heading) gallery.setAttribute('aria-labelledby', heading.id);
      mainFrame.insertAdjacentElement('afterend', gallery);
      state.gallery = gallery;
    }
    state.gallery.replaceChildren();
    state.gallery.hidden = state.views.length < 2;
    if (state.views.length < 2) return;
    state.views.forEach((view, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'cmj-ring-v2__view-thumb';
      button.dataset.cmjViewIndex = String(index);
      button.setAttribute('aria-label', view.alt);
      button.setAttribute('aria-pressed', 'false');
      const image = document.createElement('img');
      image.src = imageSize(view.src, 220);
      image.alt = '';
      image.width = 85;
      image.height = 85;
      image.loading = 'lazy';
      image.decoding = 'async';
      button.append(image);
      const label = document.createElement('span');
      label.className = 'cmj-ring-v2__view-label';
      label.textContent = state.labels[view.kind] || state.labels.detail || '';
      button.append(label);
      state.gallery.append(button);
    });
  }

  function selectVariant(root, radio, syncUrl) {
    if (!radio || (radio.disabled && syncUrl)) return;
    const state = getState(root);
    root.querySelectorAll(radioSelector).forEach(option => {
      option.checked = option === radio;
    });
    root.querySelectorAll('[data-cmj-selected-variant]').forEach(input => {
      input.value = radio.value;
    });
    const available = radio.dataset.cmjAvailable !== 'false';
    root.querySelectorAll('[data-cmj-purchase]').forEach(button => {
      button.disabled = !available || state.pending;
    });
    const availability = root.querySelector('[data-cmj-availability]');
    if (availability) availability.hidden = available;
    const price = root.querySelector('[data-cmj-ring-price]');
    if (price && radio.dataset.cmjPrice) price.textContent = radio.dataset.cmjPrice;
    const label = root.querySelector('[data-cmj-selected-label]');
    if (label) {
      label.textContent = radio.dataset.cmjName || '';
    }
    root.querySelectorAll('.cmj-ring-v2__finish-preview').forEach(row => {
      row.hidden = true;
    });
    const views = [];
    if (radio.dataset.cmjImage) {
      views.push({
        src: radio.dataset.cmjImage,
        alt: (root.querySelector('h1')?.textContent.trim() || '') + ' – ' + (radio.dataset.cmjName || ''),
        width: state.width,
        height: state.height,
        kind: 'studio'
      });
    }
    views.push(...additionalViews(root, radio.dataset.cmjColour || ''));
    views.push(...modelViews(root, radio.dataset.cmjColour || ''));
    renderViews(root, views);
    if (!state.main && state.views.length) {
      state.main = document.createElement('img');
      state.main.dataset.cmjRingImage = '';
      state.main.sizes = '(min-width: 900px) 52vw, 100vw';
      root.querySelector('.cmj-ring-v2__main')?.prepend(state.main);
    }
    if (state.main) state.main.hidden = state.views.length === 0;
    const pendingImage = root.querySelector('[data-cmj-image-pending]');
    if (pendingImage) pendingImage.hidden = state.views.length > 0;
    const caption = root.querySelector('[data-cmj-view-caption]');
    if (caption && state.views.length === 0) caption.hidden = true;
    showView(root, 0);
    state.variant = radio.value;
    updateSelection(root);
    if (syncUrl && location.pathname.includes('/products/')) {
      const url = new URL(location.href);
      url.searchParams.set('variant', radio.value);
      history.replaceState(history.state, '', url);
    }
  }

  function additionalViews(root, tone) {
    const state = getState(root);
    if (state.extraViews === null) {
      const source = root.querySelector('[data-cmj-extra-views]');
      try {
        state.extraViews = source ? JSON.parse(source.textContent) : {};
      } catch {
        state.extraViews = {};
      }
    }
    return Array.isArray(state.extraViews[tone]) ? state.extraViews[tone] : [];
  }

  function updateSelection(root) {
    const selected = root.querySelector(radioSelector + ':checked');
    const size = root.querySelector('[data-cmj-ring-size]');
    const sizeText = size?.value || root.querySelector('[data-cmj-copy-size]')?.textContent || '';
    const metalText = selected?.dataset.cmjName || root.querySelector('[data-cmj-spec-metal]')?.textContent.trim() || root.querySelector('[data-cmj-selection-metal]')?.textContent || '';
    root.querySelectorAll('[data-cmj-selection-size], [data-cmj-spec-size]').forEach(node => { node.textContent = sizeText; });
    root.querySelectorAll('[data-cmj-selection-metal], [data-cmj-spec-metal]').forEach(node => { node.textContent = metalText; });
    root.querySelectorAll('[data-cmj-product-enquiry], [data-cmj-band-enquiry]').forEach(link => {
      const url = new URL(link.href, document.baseURI);
      if (metalText) url.searchParams.set('metal', metalText);
      if (size?.value) url.searchParams.set('size', size.value);
      else url.searchParams.delete('size');
      link.href = url.href;
    });
  }

  async function submitProduct(event, root) {
    const form = event.target;
    if (!form.matches('.cmj-ring-v2__form')) return;
    event.preventDefault();
    const state = getState(root);
    if (state.pending || !form.reportValidity()) return;
    const selected = root.querySelector(radioSelector + ':checked');
    if (selected?.disabled || selected?.dataset.cmjAvailable === 'false') return;
    const destination = event.submitter?.dataset.cmjPurchase === 'checkout' ? 'checkout' : 'cart';
    const data = new FormData(form);
    data.delete('return_to');
    state.pending = true;
    form.setAttribute('aria-busy', 'true');
    const buttons = Array.from(root.querySelectorAll('[data-cmj-purchase]'));
    const previousDisabled = buttons.map(button => button.disabled);
    buttons.forEach(button => { button.disabled = true; });
    const choices = Array.from(root.querySelectorAll(radioSelector + ', [data-cmj-ring-size]'));
    const previousChoiceDisabled = choices.map(choice => choice.disabled);
    choices.forEach(choice => { choice.disabled = true; });
    const status = root.querySelector('[data-cmj-purchase-status]');
    if (status) {
      status.textContent = root.querySelector('[data-cmj-copy-pending]')?.textContent || '';
      status.hidden = false;
      status.classList.remove('is-error');
    }
    try {
      const response = await fetch(root.dataset.cmjAddUrl, {
        method: 'POST',
        body: data,
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      const result = await response.json();
      if (!response.ok || result.status >= 400) throw new Error(result.description || 'cart_add_failed');
      const url = new URL(destination === 'checkout' ? root.dataset.cmjCheckoutUrl : root.dataset.cmjCartUrl, location.origin);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview && destination === 'cart') url.searchParams.set('preview_theme_id', preview);
      location.assign(url.href);
    } catch {
      state.pending = false;
      form.removeAttribute('aria-busy');
      buttons.forEach((button, index) => { button.disabled = previousDisabled[index]; });
      choices.forEach((choice, index) => { choice.disabled = previousChoiceDisabled[index]; });
      if (status) {
        status.textContent = root.querySelector('[data-cmj-copy-error]')?.textContent || '';
        status.classList.add('is-error');
        status.focus();
      }
    }
  }

  function initialize(scope) {
    const roots = scope.matches?.(rootSelector) ? [scope] : scope.querySelectorAll(rootSelector);
    roots.forEach(root => {
      const radios = Array.from(root.querySelectorAll(radioSelector));
      if (!radios.length) {
        updateSelection(root);
        return;
      }
      const requested = new URL(location.href).searchParams.get('variant');
      const selected = radios.find(radio => radio.value === requested)
        || radios.find(radio => radio.checked)
        || radios.find(radio => !radio.disabled);
      selectVariant(root, selected, false);
    });
  }

  document.addEventListener('change', event => {
    const radio = event.target;
    if (radio.matches?.('[data-cmj-ring-size]')) {
      const root = radio.closest(rootSelector);
      if (root) updateSelection(root);
      return;
    }
    if (!radio.matches?.(radioSelector)) return;
    const root = radio.closest(rootSelector);
    if (root) selectVariant(root, radio, true);
  });

  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-cmj-view-index]');
    const root = button?.closest(rootSelector);
    if (root) showView(root, Number(button.dataset.cmjViewIndex));
  });

  document.addEventListener('submit', event => {
    const root = event.target.closest?.(rootSelector);
    if (!root) return;
    submitProduct(event, root);
  }, true);

  document.addEventListener('shopify:section:load', event => initialize(event.target));
  window.addEventListener('popstate', () => initialize(document));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
})();

